import { CSSProperties } from 'react'

import classNames from 'classnames'
import { DataItem } from 'scrivito'

import { Column } from './const'
import {
  ControlledCheckbox,
  stateTransition,
} from '@/Atomic/Atoms/Inputs/ControlledCheckbox'
import { StringText } from '@/Atomic/Atoms/StringText'
import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import DropdownMenu from '@/Atomic/Organisms/DropdownMenu'

interface TableCellProps {
  className?: string
  style?: CSSProperties
  children?: React.ReactNode
  variant?: Column
  noWrap?: boolean
  text?: string
  dataLabel?: string
  onClick?: React.MouseEventHandler<HTMLSpanElement>
  dataItem?: DataItem
  actions?: MenuItemProps[]
  actionsTrigger?: boolean
  rowId?: string
  selectRow?: (id: string, select?: boolean) => void
  isRowSelected?: (id: string) => boolean
  isRowSelectDisabled?: (id: string) => boolean
}

export const TableCell: React.FC<TableCellProps> = (props) => {
  const { className, style, variant, dataLabel } = props
  return (
    <td
      className={classNames('data-table-data', variant, className)}
      data-label={dataLabel}
      style={{ ...style }}
    >
      <Content {...props} />
    </td>
  )
}

const Content: React.FC<TableCellProps> = ({
  children,
  variant,
  noWrap,
  text,
  onClick,
  dataItem,
  actions = [],
  actionsTrigger,
  rowId,
  selectRow,
  isRowSelected,
  isRowSelectDisabled,
}) => {
  if (variant === Column.ROWSELECT) {
    return (
      <ControlledCheckbox
        checked={isRowSelected && isRowSelected(rowId || '')}
        disabled={isRowSelectDisabled && isRowSelectDisabled(rowId || '')}
        onChange={() => {
          if (selectRow && isRowSelected && rowId) {
            selectRow(rowId, stateTransition(isRowSelected(rowId)))
          }
        }}
        onClick={(e) => {
          e.stopPropagation()
        }}
      />
    )
  }

  if (variant === Column.ACTIONS) {
    return (
      <DropdownMenu
        menuItems={actions}
        buttonClassName="borderless"
        trigger={actionsTrigger}
      />
    )
  }

  if (noWrap) {
    return <>{children ?? text}</>
  }

  if (variant === Column.MAIN) {
    return (
      <StringText
        value={text}
        variant="link"
        className="underline-on-hover-only"
        dataItem={dataItem}
        onClick={onClick}
      >
        {children}
      </StringText>
    )
  }

  return <StringText value={text}>{children}</StringText>
}
